import { render, staticRenderFns } from "./msList.vue?vue&type=template&id=1a6a1b7e&scoped=true&"
import script from "./msList.vue?vue&type=script&lang=js&"
export * from "./msList.vue?vue&type=script&lang=js&"
import style0 from "./msList.vue?vue&type=style&index=0&id=1a6a1b7e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a6a1b7e",
  null
  
)

export default component.exports